import React from 'react';

import ICO_HEART from 'assets/images/ico-heart.svg';
import { useTranslation } from 'providers/GILT.provider';

const FrequentlyBtnComponent = (props) => {
  const { t } = useTranslation();

  return (
    <div className="frequently-btn" onClick={props.onClickFrequentBtn} role="menuitem" tabIndex={0}>
      <img src={ICO_HEART} alt="Frequently booked services" />
      <span className="item-name f-b">{t('scheduler.booking.frequentlyBookedServices')}</span>
    </div>
  );
};
export default FrequentlyBtnComponent;
